// Which devices take a release at a given rollout percentage. The bucket
// depends only on the device ID, never on the release, so the same 1% are
// canaries every time. The agent must compute exactly this:
//   bucket = ((sha256(device_id_ascii)[0] << 8) | sha256(...)[1]) % 100
//   admitted = bucket < rollout_pct

export const ROLLOUT_STAGES = [1, 5, 25, 100] as const;

export async function rolloutBucket(deviceId: string): Promise<number> {
  const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(deviceId.toLowerCase())));
  return ((digest[0]! << 8) | digest[1]!) % 100;
}

export function nextStage(pct: number): number | null {
  return ROLLOUT_STAGES.find((s) => s > pct) ?? null;
}

/** Auto-halt rule: failure rate above twice the previous release's baseline, once enough attempts exist. */
export function shouldHalt(failed: number, attempts: number, baselinePct: number, minAttempts = 20): boolean {
  if (attempts < minAttempts) return false;
  return (failed / attempts) * 100 > baselinePct * 2;
}
